<template>
  <div>
    <ContentPage headerText="About Us">
      <p>
        Specialists in painting sash windows, doors and exteriors of properties.
        Working throughout East Anglia and Greater London.
      </p>
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="sections">
          <div>
            <h2>Working with Sash Window Preservation Ltd</h2>

            <p>
              We work alongside Sash Window Preservation Ltd giving you the
              highest standard of painting once your Sash Windows have been
              repaired/replaced.
            </p>

            <p>
              Based in Norwich, we have a friendly professional team of painters
              who work to a very high standard.
            </p>
          </div>

          <div>
            <h2>Quality Paint, Your Choice of Colour</h2>

            <p>
              At Rococo we provide you with your brand of paint and colour.
              <a
                href="https://www.farrow-ball.com/"
                target="_blank"
                rel="noopener noreferrer"
                class="underline"
                >Farrow and Ball</a
              >
              and
              <a
                href="https://www.dulux.co.uk/"
                target="_blank"
                rel="noopener noreferrer"
                class="underline"
                >Dulux</a
              >
              are most popular, providing you with the highest quality of paint
              in a large choice of colours.
            </p>

            <p>
              We also use Sikkens paint for our exterior work. This high quality
              paint protects the timber for many years, has excellent durability
              and a flexible coating which prevents cracking and flaking.
            </p>
          </div>

          <div>
            <h2>Extensive Preparation, Lasting Finish</h2>

            <p>
              Our quotes for sash windows/doors include extensive preparation,
              often sanding all the way back to bare timber. Masonry sills are
              repaired and smoothed with a choice of masonry paints, and we
              prime, undercoat and then top coat in your choice of colour, both
              inside and out.
            </p>

            <p>
              We can access any height with our scaffold tower or cherry picker.
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPage from '@/components/partials/ContentPage.vue'

export default {
  name: 'about-us',
  metaInfo: {
    title: 'About Us',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Norwich-based painting specialists working alongside Sash Window Preservation Ltd. Farrow & Ball, Dulux and Sikkens — your choice of paint and colour, applied to the highest standard.'
      }
    ]
  },
  components: {
    ContentPage
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/breakpoints";
@import "../../assets/styles/variables/colors";

.content {
  padding-top: 64px;
  padding-bottom: 64px;
}

.sections {
  display: flex;
  flex-direction: column;
  gap: 5rem;

  > * {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AboutUs.vue